export const LOAD_EMPLOYER_SAVED_FILTER_SELECTION_START =
  'LOAD_EMPLOYER_SAVED_FILTER_SELECTION_START';
export const LOAD_EMPLOYER_SAVED_FILTER_SELECTION_SUCCESS =
  'LOAD_EMPLOYER_SAVED_FILTER_SELECTION_SUCCESS';
export const LOAD_EMPLOYER_SAVED_FILTER_SELECTION_FAILURE =
  'LOAD_EMPLOYER_SAVED_FILTER_SELECTION_FAILURE';

export const LOAD_TEACHER_SAVED_FILTER_SELECTION_START =
  'LOAD_TEACHER_SAVED_FILTER_SELECTION_START';
export const LOAD_TEACHER_SAVED_FILTER_SELECTION_SUCCESS =
  'LOAD_TEACHER_SAVED_FILTER_SELECTION_SUCCESS';
export const LOAD_TEACHER_SAVED_FILTER_SELECTION_FAILURE =
  'LOAD_TEACHER_SAVED_FILTER_SELECTION_FAILURE';
